import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVerticalBarsStacked100 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="var(--dataviz-color-sequential-blue-scale05)"
      fillRule="evenodd"
      d="M6.583 25.226h4.74v-5.418h-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale02)"
      fillRule="evenodd"
      d="M6.583 13.418h4.74V3.773c0-.749-.607-1.355-1.355-1.355h-2.03c-.749 0-1.355.606-1.355 1.355z"
      clipRule="evenodd"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale03)"
      fillRule="evenodd"
      d="M6.583 19.808h4.74v-7h-4.74zm7.451-3.39h4.74v-6h-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale05)"
      fillRule="evenodd"
      d="M14.034 25.227h4.74v-9.483h-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale02)"
      fillRule="evenodd"
      d="M14.034 10.418h4.74V3.773c0-.749-.607-1.355-1.355-1.355h-2.03c-.749 0-1.355.606-1.355 1.355z"
      clipRule="evenodd"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale03)"
      fillRule="evenodd"
      d="M21.485 17.418h4.74v-8h-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale05)"
      fillRule="evenodd"
      d="M21.485 25.226h4.741V17.1h-4.741v8.127Z"
      clipRule="evenodd"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale02)"
      fillRule="evenodd"
      d="M21.485 9.418h4.74V3.773c0-.749-.607-1.355-1.355-1.355h-2.03c-.749 0-1.355.606-1.355 1.355z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVerticalBarsStacked100;
